// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YFBM","top":"styles_top__3uRWO"};